import * as React from 'react';
import Typography from '@material-ui/core/Typography';

import { withIntl, IntlProps } from 'ha/i18n';
import { RulesValue, RulesFilterValue } from 'ha/types/SearchFilters';
import FilterCheckbox from './FilterCheckbox';

interface Props {
  rules: RulesFilterValue;
  className?: string;
  onToggle: (type: string, selected: boolean) => void;
}

export const RulesFilter: React.SFC<Props & IntlProps> = ({
  rules,
  onToggle,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Rules')}</Typography>

    <FilterCheckbox
      name={`${RulesValue.SMOKING}-checkbox`}
      isActive={rules.includes(RulesValue.SMOKING)}
      onToggle={(selected: boolean) => onToggle(RulesValue.SMOKING, selected)}
      data-test-locator="Filter Smoking Allowed"
    >
      {T('Smoking allowed')}
    </FilterCheckbox>
    <FilterCheckbox
      name={`${RulesValue.PETS}-checkbox`}
      isActive={rules.includes(RulesValue.PETS)}
      onToggle={(selected: boolean) => onToggle(RulesValue.PETS, selected)}
      data-test-locator="Filter Pets Allowed"
    >
      {T('Pets allowed')}
    </FilterCheckbox>
    <FilterCheckbox
      name={`${RulesValue.INSTRUMENT}-checkbox`}
      isActive={rules.includes(RulesValue.INSTRUMENT)}
      onToggle={(selected: boolean) =>
        onToggle(RulesValue.INSTRUMENT, selected)
      }
      data-test-locator="Filter Playing Instrument Allowed"
    >
      {T('Playing instrument allowed')}
    </FilterCheckbox>
  </React.Fragment>
);

export default withIntl(RulesFilter);
